// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-setting"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14C19.6569 14 21 15.3431 21 17Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 20H2V3.5H9L11 6H22V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.9999 14V12.75M17.9999 14C16.3431 14 14.9999 15.3431 14.9999 17C14.9999 18.6569 16.3431 20 17.9999 20M17.9999 14C19.6568 14 20.9999 15.3431 20.9999 17C20.9999 18.6569 19.6568 20 17.9999 20M17.9999 20V21.25M15.4019 15.5L14.3193 14.875M20.598 18.5L21.6806 19.125M20.598 15.5L21.6806 14.875M15.4019 18.5L14.3193 19.125","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderSettingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-setting',
    ref,
    icon: element,
  },
));

FolderSettingIcon.displayName = 'FolderSettingIcon';

export default FolderSettingIcon;
